module.exports = __webpack_public_path__ + "media/src/components/EmployerProfile/img/glassdoorHoverIcon-045af70253657463fadeddc1ef7abf42.svg";